// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  width: max-content;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 3px 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.avatar-icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  margin-top: 2px;
  border-radius: 50%;
  border: 1px solid #009858;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/post/components/PostHeader.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,6BAAA;AACF;;AAEA;EACE,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AACF","sourcesContent":[".tooltip-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.tooltip-text {\r\n  visibility: hidden;\r\n  width: max-content;\r\n  background-color: #333;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 3px 8px;\r\n  border-radius: 4px;\r\n  position: absolute;\r\n  z-index: 10;\r\n  top: -30px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.tooltip-wrapper:hover .tooltip-text {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.avatar-icon {\r\n  width: 15px;\r\n  height: 15px;\r\n  margin-right: 10px;\r\n  margin-top: 2px;\r\n  border-radius: 50%;\r\n  border: 1px solid #009858;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
